import { render, staticRenderFns } from "./SmelteryStation.vue?vue&type=template&id=221a0b54"
import script from "./SmelteryStation.vue?vue&type=script&lang=js"
export * from "./SmelteryStation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports